import React from 'react';

interface TabIconProps {
  active: boolean;
}

const SubsidiesIcon: React.FC<TabIconProps> = ({ active }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6041 18.3346C6.00172 18.3346 2.27075 14.6037 2.27075 10.0013C2.27075 5.39893 6.00172 1.66797 10.6041 1.66797C15.2064 1.66797 18.9374 5.39893 18.9374 10.0013C18.9374 14.6037 15.2064 18.3346 10.6041 18.3346ZM10.6041 16.6679C14.286 16.6679 17.2708 13.6832 17.2708 10.0013C17.2708 6.3194 14.286 3.33464 10.6041 3.33464C6.92219 3.33464 3.93742 6.3194 3.93742 10.0013C3.93742 13.6832 6.92219 16.6679 10.6041 16.6679ZM8.9791 9.16793H13.1041V10.8346H8.9791C9.1721 11.7856 10.0129 12.5013 11.0208 12.5013C11.5334 12.5013 12.0028 12.3162 12.3657 12.009L13.7832 12.954C13.0978 13.7003 12.1139 14.1679 11.0208 14.1679C9.09052 14.1679 7.50091 12.7096 7.29364 10.8346H6.43742V9.16793H7.29364C7.50091 7.29299 9.09052 5.83463 11.0208 5.83463C12.1139 5.83463 13.0978 6.30236 13.7832 7.0486L12.3658 7.9936C12.0029 7.68648 11.5334 7.5013 11.0208 7.5013C10.0129 7.5013 9.1721 8.21704 8.9791 9.16793Z"
      fill={active ? '#4E3178' : '#738290'}
    />
  </svg>
);

export default SubsidiesIcon;
